import { format, parseISO, isValid } from 'date-fns';

export const formatDate = (date, formatStr = 'yyyy-MM-dd') => {
    if (!date) return '';

    const parsedDate = typeof date === 'string' ? parseISO(date) : date;

    if (!isValid(parsedDate)) return '';

    return format(parsedDate, formatStr);
};

export const formatDateDisplay = (date) => {
    return formatDate(date, 'MMMM d, yyyy');
};

export const isValidDate = (date) => {
    if (!date) return false;
    const parsedDate = typeof date === 'string' ? parseISO(date) : date;
    return isValid(parsedDate);
};

export const getTodayString = () => {
    return format(new Date(), 'yyyy-MM-dd');
};

// Parse a date string (yyyy-MM-dd) as a local date, avoiding timezone shifts
export const parseLocalDate = (dateString) => {
    if (!dateString) return null;

    // If it's already a Date object, return it
    if (dateString instanceof Date) return dateString;

    // For yyyy-MM-dd strings, create a local date to avoid timezone issues
    if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const [year, month, day] = dateString.split('-').map(Number);
        return new Date(year, month - 1, day);
    }

    // Fallback to parseISO for other formats
    return parseISO(dateString);
};